import React from 'react';
import { AnimatedSkeletonProgress } from './animated-skeleton-progress';
import { createStyles } from '@/contexts/theme-context';
import { useCurrentDownloadPercentage } from '@/contexts/offline-download-management-context';
import { View } from 'react-native';

const OFFLINE_DOWNLOAD_PROGRESS_BAR_HEIGHT = 3;

export const OfflineDownloadProgressBar: React.FC = () => {
  const [styles, theme] = useStyles();
  const downloadPercentage = useCurrentDownloadPercentage();

  return downloadPercentage > 0 && downloadPercentage < 100 ? (
    <View
      accessibilityRole="progressbar"
      accessible
      role="progressbar"
      style={styles.container}
    >
      <AnimatedSkeletonProgress
        backgroundColor={theme.sk.color.loader.skeleton}
        height={OFFLINE_DOWNLOAD_PROGRESS_BAR_HEIGHT}
        progressBarColor={theme.sk.color.bg.checkbox.active}
        progressPercentage={downloadPercentage}
      />
    </View>
  ) : null;
};

const useStyles = createStyles(() => ({
  container: {
    marginBottom: -OFFLINE_DOWNLOAD_PROGRESS_BAR_HEIGHT,
  },
}));
